import { render } from "./InsightsView.vue?vue&type=template&id=574b5b56"
import script from "./InsightsView.vue?vue&type=script&lang=js"
export * from "./InsightsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__